import globalDuck from './global/global.duck';
import userDuck from './user/user.duck';
import carDetailsDuck from './carDetails/carDetails.duck';
import dealerDuck from './dealer/dealer.duck';
import navigationDuck from './navigation/navigation.duck';
import financeWidgetDuck from './financeWidget/financeWidget.duck';
import UIDuck from './commonDucks/ui.duck';

export { userDuck, carDetailsDuck, dealerDuck, financeWidgetDuck, globalDuck, UIDuck, navigationDuck };
export * from './redux.interface';

export * from './filters/filter.duck';
export * from './trimSelector/trimSelector.duck';
export * from './content/content.duck.interface';
export * from './carDetails/carDetails.duck';
export * from './commonDucks/ui.duck';
export * from './commonDucks/ui.duck.interface';
export * from './financeWidget/financeWidget.duck';
export * from './global/global.duck';
export * from './redux.interface';
export * from './configurator/configurator.duck';
